var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
function ChevronRight(props) {
    return (React.createElement("svg", __assign({ xmlns: 'http://www.w3.org/2000/svg', height: '48', width: '48' }, props),
        React.createElement("path", { d: 'M18.75 36 16.6 33.85 26.5 23.95 16.6 14.05 18.75 11.9 30.8 23.95Z' })));
}
export default ChevronRight;
//# sourceMappingURL=chevron-right.js.map